module.exports = __webpack_public_path__ + "static/golden-fox-d80697c7d879cece190549b2103c4cc1.jpg";